import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';

export default function ArrowIcon({ open, color }) {
  return open ? <KeyboardArrowDownIcon color={color} /> : <KeyboardArrowRightIcon color={color} />;
}
